// extracted by mini-css-extract-plugin
export default {"button":"Button_button__xFm3H","noDesign":"Button_noDesign__eNrpF","backButton":"Button_backButton__x0xbe"};